import { Navbar } from './components/Navbar';
import { Router, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Project } from './pages/Project';
import { Resume } from './pages/Resume';
import { Contact } from './pages/Contact';
import './index.css';

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-t from-cyan-500 to-blue-600">
      <Navbar />
      <Routes>
        
        <Route path="/" element={<Home />} />
        <Route path="/project" element={<Project />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/contact" element={<Contact />} />

      </Routes>
    </div>
  );
}

export default App;
